
export const feesApportionPartyPaths = {
  '/fees-apportion-parties': {
    get: {
      summary: 'List all fees apportion parties',
      operationId: 'listFeesApportionParties',
      responses: {
        '200': {
          description: 'A list of fees apportion parties',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: {
                  $ref: '#/components/schemas/FeesApportionParty',
                },
              },
            },
          },
        },
      },
    },
    post: {
      summary: 'Create a new fees apportion party',
      operationId: 'createFeesApportionParty',
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/FeesApportionParty',
            },
          },
        },
      },
      responses: {
        '201': {
          description: 'The created fees apportion party',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/FeesApportionParty',
              },
            },
          },
        },
      },
    },
  },
  '/fees-apportion-parties/{id}': {
    get: {
      summary: 'Get a fees apportion party by ID',
      operationId: 'getFeesApportionParty',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '200': {
          description: 'The requested fees apportion party',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/FeesApportionParty',
              },
            },
          },
        },
      },
    },
    patch: {
      summary: 'Update a fees apportion party',
      operationId: 'updateFeesApportionParty',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/FeesApportionParty',
            },
          },
        },
      },
      responses: {
        '200': {
          description: 'The updated fees apportion party',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/FeesApportionParty',
              },
            },
          },
        },
      },
    },
    delete: {
      summary: 'Delete a fees apportion party',
      operationId: 'deleteFeesApportionParty',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '204': {
          description: 'Fees apportion party deleted successfully',
        },
      },
    },
  },
};
